/*
 * *****************************************************************************
 *  Copyright (C)  Motorola Solutions, INC.
 *  All Rights Reserved.
 *  Motorola Solutions Confidential Restricted.
 * *****************************************************************************
 */

export interface UiSettings {
    uuid: string;
    systemReconnectPeriod: number;
    correlationPeriod: number;
    historyDepth: number;
    historyAge: number;
    recentCallLimit: number;
    headsetDisconnectRecoveryPeriod: number;
    defaultSettings: boolean;
    supervisorSettings: SupervisorSettings;
    useStun: boolean;
    jitterBufferTarget: number,
    firmwareUpgradeMode: FirmwareUpgradeMode
}

export enum FirmwareUpgradeMode {
    'MANUAL' = 'MANUAL',
    'PROMPTED'= 'PROMPTED',
    'AUTOMATIC' = 'AUTOMATIC'
}

export interface SupervisorSettings {
    callerDeafened: boolean;
    ringback: boolean;
}
